import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoadingState {
    loading: boolean;
}

const initialState: LoadingState = {
    loading: true
}

const loadingSlice = createSlice({
    name :"loading",
    initialState,
    reducers : {
        setLoading(state, action: PayloadAction<boolean>){
            state.loading = action.payload;
        }
    }
})

export const {setLoading} = loadingSlice.actions
export default loadingSlice.reducer;